<template>
  <div class="login">
    <ValidationObserver v-slot="{ invalid, handleSubmit }" class="observer">
      <form class="login__container" @submit.prevent="handleSubmit(logIn)">
        <div class="login-title">
          <img class="logo__img" src="../../assets/images/Logoauth.svg" alt="logo"/>
          <h2 class="auth-title">Вход в аккаунт</h2>
          <div class="register-cta">
            <p class="action-text">Нет аккаунта?</p>
            <div class="additional-info__password" @click="goToRegister">
              <p style="color: #FAC514;">Зарегистрироваться</p>
            </div>
          </div>
        </div>
        <div class="inputs" style="margin-top: 50px">
          <BaseInput
            :placeholder="$t('auth.login')"
            rules="required"
            v-model="login"
            :class="inputErrorClass"
          />
          <div class="password-input-wrapper" style="margin-top: 30px">
            <BaseInput
              :placeholder="$t('auth.password')"
              rules="required"
              v-model="password"
              :type="passwordFieldType"
              :class="inputErrorClass"
            />
            <button type="button" class="toggle-password" @click="togglePasswordVisibility">
              <img
                :src="passwordFieldType === 'password' ? require('@/assets/icons/eye-off.svg') : require('@/assets/icons/eye.svg')"
                alt="toggle visibility">
            </button>
          </div>
        </div>
        <div v-if="errorMessage" class="error-message">
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0003 6.16797V9.5013M10.0003 12.8346H10.0087M18.3337 9.5013C18.3337 14.1037 14.6027 17.8346 10.0003 17.8346C5.39795 17.8346 1.66699 14.1037 1.66699 9.5013C1.66699 4.89893 5.39795 1.16797 10.0003 1.16797C14.6027 1.16797 18.3337 4.89893 18.3337 9.5013Z"
              stroke="#F04438" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ errorMessage }}
        </div>
        <div class="additional-info">
          <div style="width: 100%; margin-bottom: 35px">
            <BaseButton
              style="width: 100%"
              btnColor="gold"
              :disabled="invalid"
              :label="$t('auth.logIn')"
              type="submit"
            />
            <div style=" margin: 10px 0; display: flex; align-items: center">
              <hr style="flex: 1; color: rgba(255,255,255,0.1)"/>
              <p style="text-align: center; margin: 0 10px; color: #999999">или</p>
              <hr style="flex: 1; color: rgba(255,255,255,0.1)"/>
            </div>
            <div class="telegram-btn"><img src="../../assets/icons/Telegram.svg" alt="logo">
              <p>Продолжить в телеграмм</p></div>
          </div>
          <p style="margin-right: 5px;font-size: 14px; line-height: 150%">Возникли сложности со входом?</p>
          <div class="additional-info__password" @click="goToForgot">
            <p>Сбросьте пароль</p>
          </div>
          <p style="margin-right: 5px; font-size: 14px; line-height: 150%">или</p>
          <div class="additional-info__password">
            <p>Свяжитесь с поддержкой</p>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
import BaseCheckbox from '../base/BaseCheckbox.vue'
import BaseInput from '../base/BaseInput.vue'

export default {
  components: {BaseInput, BaseButton, BaseCheckbox},
  data() {
    return {
      login: '',
      password: '',
      rememberMe: false,
      errorMessage: '',
      passwordFieldType: 'password'
    }
  },
  computed: {
    inputErrorClass() {
      return this.errorMessage ? 'input-error' : ''
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    goToRegister() {
      this.$router.push('/register')
      this.$store.dispatch('openAuthModal', false)
    },
    goToForgot() {
      this.$router.push('/forgot-password')
      this.$store.dispatch('openAuthModal', false)
    },
    async logIn() {
      this.errorMessage = ''
      const data = {
        login: this.login,
        password: this.password,
        rememberMe: this.rememberMe
      }
      const response = await this.$auth.loginWith(data)
      await this.$router.push('/')
      if (response.success === false) {
        this.errorMessage = response.errorMessage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/auth/login.scss';

.error-message {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #F04438;
  margin-bottom: 25px;

  svg {
    margin-right: 10px;
  }
}

.input-error {
  background-color: rgba(240, 68, 56, 0.08) !important;
  color: #F04438 !important;
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  background: none;
}

.toggle-password img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue